import LandingContext from './LandingContext'

import useYearMakeModel from './useYearMakeModel'
import useExperienceState from './useExperienceState'
import useGroupDealerFetcher from './useGroupDealerFetcher'
import usePlateVinFetcher from './usePlateVinFetcher'
import useProspectDocuments from './useProspectDocuments'
import {
  useEdgeDataFetcherTrims,
  useEdgeDataFetcherEligibility,
  useEdgeDataFetcherImages,
  useEdgeDataFetcherDetail,
  useEdgeDataFetcherOptions,
  useEdgeDataFetcherVehicleSpecs,
  useEdgeGetDealerReps,
  useLambdaDynamicDataFetcher,
  useForceAnswer,
  useEdgeDataFetcherForVerification,
  useRunHistoryPage,
  useEdgeDataFetcherHealthCheck
} from './useEdgeDataFetcher'
import useZipDataFetcher from '../hooks/useZipDataFetcher'
import useProspectOffer from './useProspectOffer'
import useVerifyRecaptcha from './useVerifyRecaptcha'
import useDataLayer from './useDataLayer'
import useVinValidators from './useVinValidators'
import useRegisterMyKBB from './useRegisterMyKBB'
import useNavigateFromLanding from './useNavigateFromLanding'
import { useCadsData } from './useCadsData'
import useOptimizely from './useOptimizely'
import useVoiVin from './useVoiVin'
import useLandingWebComponent from './useLandingWebComponent'
import useEventBusAnalyticsListener from '../components/generic/useEventBusAnalyticsListener'

const details = ['color', 'engine', 'drivetrain', 'transmission'] //'eligibility',
export default (location, pageContext) => {
  // IMPORTANT: this should be first line!!! it sets up location.initQueryParams and location.initPathParams
  const { experienceState, qxData, globalState, updateGlobalState, offerGot, offerError, offerIsFetching } = useExperienceState(location, pageContext)
  if (experienceState.isAdminInitMode) return { initMode: true }

  const offerSubmitLink = location.state && location.state.offer && location.state.offer.offerId === globalState.offerIdSubmit
  const locationOffer = offerSubmitLink && location.state.offer
  const offer = locationOffer || offerGot

  const { ymmContext, yearParam, yearQuery, makeQuery, modelQuery } = useYearMakeModel(location, pageContext, offer)

  const landingContext = new LandingContext(ymmContext, pageContext, location, globalState, updateGlobalState, yearParam, yearQuery, makeQuery, modelQuery, experienceState, qxData, offer, offerError, offerIsFetching, !!locationOffer)
  if (offer && !offer.quickQuote && !offer.isExpired && !(offer.status.toLowerCase() === 'auction')) {
    landingContext.isEdit = true
  }

  landingContext.offerIsFetching = offerIsFetching

  useEdgeDataFetcherHealthCheck(landingContext)

  useLambdaDynamicDataFetcher(landingContext)

  useGroupDealerFetcher(landingContext, globalState)

  usePlateVinFetcher(landingContext)

  useEdgeDataFetcherTrims(landingContext, pageContext, location)

  //needs to be above, but after trim load and plate vin
  useVinValidators(landingContext, location)

  useEdgeDataFetcherEligibility(landingContext, pageContext)

  useEdgeDataFetcherImages(landingContext, pageContext)

  useCadsData(landingContext, pageContext)

  details.forEach(detail => useEdgeDataFetcherDetail(landingContext, pageContext, detail, location))

  useEdgeDataFetcherOptions(landingContext, pageContext)

  useEdgeDataFetcherVehicleSpecs(landingContext)

  useProspectDocuments(landingContext, experienceState.customerInfo)

  useVoiVin(landingContext, experienceState, location)

  useZipDataFetcher(landingContext, location, updateGlobalState, globalState)

  useVerifyRecaptcha(landingContext, updateGlobalState, globalState)

  useProspectOffer(landingContext, updateGlobalState, globalState)

  useEdgeGetDealerReps(landingContext)

  useOptimizely(landingContext, location, updateGlobalState)

  useRegisterMyKBB(landingContext)

  useNavigateFromLanding(landingContext, updateGlobalState)

  useEdgeDataFetcherForVerification(landingContext, pageContext, location)

  useForceAnswer(landingContext)

  useRunHistoryPage(landingContext, pageContext, location)

  useLandingWebComponent(landingContext)

  useEventBusAnalyticsListener(globalState, updateGlobalState)

  // This needs to be last to make sure everything it needs is loaded
  useDataLayer(landingContext, location)

  return landingContext
}
